/* eslint-disable import/prefer-default-export */
import $ from 'jquery';

const GetFunction = function GetFunction() {
  this.data = {};
  this.callbacks = [];

  this.Product = (productlist, callback, clearList) => {
    if (!productlist) {
      throw Error('Products list is required!');
    }

    if (!this.data.Product) {
      this.data.Product = {
        format: 'json',
        params: {
          products: productlist,
        },
      };
    } else {
      if (clearList) {
        this.data.Product.params.products = productlist;
      } else {
        this.data.Product.params.products += `,${productlist}`;
      }
    }

    if (callback) {
      this.callbacks.push(callback);
    }
  };

  this.Hotspots = ({ zonesNames, components, zonesTypes }, callback) => {
    if (!zonesNames || !components || !zonesTypes) {
      throw Error('Products list is required!');
    }

    this.data.Hotspots = {
      format: 'json',
      params: {
        action: 'get-hotspots-html',
        'zones-names': zonesNames,
        components,
        'zones-types': zonesTypes,
      },
    };

    const products = document.querySelectorAll('.hotspot .product__name_wrapper');
    products.forEach((product) => {
      const link = product.querySelector('.product__name');
      const name = link.innerHTML;
      if (name.indexOf('OstroVit Pharma') > -1) {
        if (product.querySelector('.product__name_firm'))
          product.querySelector('.product__name_firm').remove();
        const firm = document.createElement('SMALL');
        firm.classList.add('product__name_firm');
        firm.innerHTML = 'Ostrovit Pharma';
        product.before(firm);
        link.innerHTML = name.substr(15);
        return;
      }
      if (name.indexOf('OstroVit') > -1) {
        if (product.querySelector('.product__name_firm'))
          product.querySelector('.product__name_firm').remove();
        const firm = document.createElement('SMALL');
        firm.classList.add('product__name_firm');
        firm.innerHTML = 'Ostrovit';
        product.before(firm);
        link.innerHTML = name.substr(9);
      }
    })

    if (callback) {
      this.callbacks.push(callback);
    }
  };

  this.Wishlist = (callback) => {
    this.data.Wishlist = {};

    if (callback) {
      this.callbacks.push(callback);
    }
  };

  this.Basket = (callback) => {
    this.data.Basket = {};

    if (callback) {
      this.callbacks.push(callback);
    }
  };

  this.Snippets = (fn, arg) => {
    this.data.Snippets = {
      format: 'json',
      params: {
        mobile: arg.mobile,
        tablet: arg.tablet,
        pc: arg.pc,
        request_uri: arg.request_uri,
        additional_ajax: arg.additional_ajax,
      },
    };
    this.callbacks.push(fn);
  };

  this.ToplayersAndWidgets = (fn, arg) => {
    this.data.ToplayersAndWidgets = {
      format: 'json',
      params: {
        mobile: arg.mobile,
        tablet: arg.tablet,
        pc: arg.pc,
        request_uri: arg.request_uri,
        additional_ajax: arg.additional_ajax,
      },
    };
    this.callbacks.push(fn);
  };

  this.init = () => {
    const serializedData = JSON.stringify(this.data);
    const self = this;

    $.ajax({
      url: '/ajax/get.php',
      type: 'POST',
      dataType: 'JSON',
      data: `request=${serializedData}&getAjax=true`,
      success: (response) => {
        self.cache = response;
        self.callbacks.forEach((cb) => cb(response));
      },
    });
  };
};

export const Get = new GetFunction();

export default GetFunction;
